<template>
  <div
    id="mobile-menu"
    class="bg-white px-8 lg:hidden"
    :class="{ hidden: !navopened }"
  >
    <div class="space-y-1 px-2 pb-3 pt-2 sm:px-3">
      <NuxtLink
        to="/"
        class="block px-3 py-2 text-base font-medium text-gray-600"
        aria-current="page"
      >Home
      </NuxtLink>
      <NuxtLink
        to="#About"
        class="block px-3 py-2 text-base font-medium text-gray-600 hover:text-gray-800"
      >Product
      </NuxtLink>
      <NuxtLink
        to="#FAQ"
        class="text-md block px-3 py-2 text-base font-medium text-gray-600 hover:text-gray-800"
      >
        FAQ
      </NuxtLink>
      <NuxtLink
        to="/contact-us"
        class="block px-3 py-2 text-base font-medium text-gray-600 hover:text-gray-800"
      >Let's Talk</NuxtLink>
    </div>
    <div
      v-if="$store.auth.isLoggedIn"
      class="border-t border-gray-700 pb-3 pt-4"
    >
      <button
        type="button"
        class="flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-200"
        aria-expanded="false"
        aria-haspopup="true"
        @click.prevent="toggleDropdown"
      >
        <avatar
          class="h-10 w-10 rounded-full"
          variant="beam"
          :colors="colors"
          :name="$store.auth.authenticatedUser.first_name"
        />
      </button>
      <div class="mt-3 space-y-1 px-2 sm:px-3">
        <NuxtLink
          v-if="$store.auth.authenticatedUser.is_zuno_engineer === true"
          to="/admin/home"
          class="block px-4 py-2 text-sm text-gray-700"
          role="menuitem"
          tabindex="-1"
        >Dashboard</NuxtLink>
        <NuxtLink
          v-if="$store.auth.authenticatedUser.is_zuno_engineer === false"
          to="/dashboard/home"
          class="block px-4 py-2 text-sm text-gray-700"
          role="menuitem"
          tabindex="-1"
        >Dashboard</NuxtLink>
        <a
          href="#"
          class="block px-4 py-2 text-sm text-gray-700"
          role="menuitem"
          tabindex="-1"
          @click="logout"
        >Logout</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileNavbar',
}
</script>
